const { DataSourceType, Module } = require('../prisma/types');

const availableAddons = [{
  value: 'dedicatedAnalyst',
  label: 'Dedicated analyst',
}, {
  value: 'unlimitedHeatmaps',
  label: 'Unlimited heatmaps and recordings',
}];

const dataSourceModules = {
  [DataSourceType.Website]: [Module.Analytics, Module.UxSurveys, Module.Heatmaps, Module.Accessibility],
  [DataSourceType.Cx]: [Module.CxSurveys],
};

const LICENSE_LEVELS = {
  FREE: {
    value: 1,
    label: 'Free',
  },
  INSIGHTS: {
    value: 2,
    label: 'Insights',
  },
  INSIGHTS_PRO: {
    value: 3,
    label: 'Insights Pro',
  },
  BUSINESS: {
    value: 5,
    label: 'Business',
  },
  ENTERPRISE: {
    value: 6,
    label: 'Enterprise',
  },
};

module.exports = {
  availableAddons,
  dataSourceModules,
  LICENSE_LEVELS,
};
